import { render, staticRenderFns } from "./default.vue?vue&type=template&id=5650e9bd&scoped=true"
import script from "./default.vue?vue&type=script&lang=js"
export * from "./default.vue?vue&type=script&lang=js"
import style0 from "./default.vue?vue&type=style&index=0&id=5650e9bd&prod&lang=css"
import style1 from "./default.vue?vue&type=style&index=1&id=5650e9bd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5650e9bd",
  null
  
)

export default component.exports